@if (!isNewApplicant) {
  <ul id="mainMenu" class="mainMenu inlineList">
    @if (canShowMenu.dashboard) {
      @if (!isNewApplicant) {
        <li routerLinkActive="active">
          <a routerLink="/dashboard">Dashboard</a>
        </li>
      }
      @if (isNewApplicant) {
        <li routerLinkActive="active">
          <a routerLink="/dashboard/new-application">Dashboard</a>
        </li>
      }
    }
    @if (!isAccreditor && !isFederation) {
      <li role="none" class="hasSubMenu" [ngClass]="{'menuOpen':myWorkOpen}"
        routerLinkActive="active"
        >
        <a href="#myWorkMenu"
          role="menuitem"
          (click)="toggleMyWorkOpen($event)"
          aria-haspopup="true"
          [attr.aria-expanded]="myWorkOpen"
          >
          MY WORK
        </a>
        @if (myWorkOpen) {
          <ul class="submenu inlineList" id="myWorkMenu" aria-label="MY WORK">
            <li [ngClass]="{'inactiveMenuItem': !canShowMenu.hasMenuAssessment}" routerLinkActive="active">
              @if (canShowMenu.hasMenuAssessment) {
                <a routerLink="/projects">
                  Projects
                </a>
              }
              @if (!canShowMenu.hasMenuAssessment) {
                <span class="noLink" aria-label="Projects - You do not have access to this page"
                  >
                  Projects
                </span>
              }
            </li>
            <!-- single or multiple profile -->
            @if (canShowMenu.hasMenuInstitutionalDirectory) {
              <app-accreditation-profile
                [profiles]="accreditationProfiles"
                [annualUpdate]="false"
                >
              </app-accreditation-profile>
            }
            @if (canShowMenu.hasMenuProgramDirectory) {
              <app-program-profile
                [profiles]="programProfiles"
                [annualUpdate]="false"
              ></app-program-profile>
            }
            @if (!canShowMenu.hasMenuInstitutionalDirectory && !canShowMenu.hasMenuProgramDirectory) {
              <li
                class="inactiveMenuItem">
                <span class="noLink" aria-label="Profile - You do not have access to this page">
                  Profile
                </span>
              </li>
            }
            <!-- single or multiple annual update -->
            @if (canShowMenu.hasMenuInstitutionalDirectory) {
              <app-accreditation-profile
                [profiles]="accreditationProfiles"
                [annualUpdate]="true"
                >
              </app-accreditation-profile>
            }
            @if (canShowMenu.hasMenuProgramDirectory) {
              <app-program-profile
                [profiles]="programProfiles"
                [annualUpdate]="true"
              ></app-program-profile>
            }
            @if (!canShowMenu.hasMenuInstitutionalDirectory && !canShowMenu.hasMenuProgramDirectory) {
              <li
                class="inactiveMenuItem">
                <span class="noLink" aria-label="Annual Reports - You do not have access to this page">
                  Annual Report
                </span>
              </li>
            }
          </ul>
        }
      </li>
    }
    @if (canShowMenu.reports) {
      <li [ngClass]="{'inactiveMenuItem': !canShowMenu.reports}" routerLinkActive="active">
        @if (canShowMenu.reports) {
          <a
            routerLink="/reports"
            role="menuitem"
            >
            REPORTS
          </a>
        }
        @if (!canShowMenu.reports) {
          <span class="noLink" aria-label="Reports - You do not have access to this page"
            >
            REPORTS
          </span>
        }
      </li>
    }
    @if (!isAccreditor && canShowMenu.hasMenuLearningAssessment) {
      <li role="none" class="hasSubMenu" [ngClass]="{'menuOpen':libraryOpen}"
        >
        <a href="#libraryMenu"
          role="menuitem"
          (click)="toggleLibraryOpen($event)"
          aria-haspopup="true"
          [attr.aria-expanded]="libraryOpen"
          >
          BETA
        </a>
        @if (libraryOpen) {
          <ul class="submenu inlineList" id="libraryMenu" aria-label="LIBRARY">
            <li [ngClass]="{'inactiveMenuItem': !canShowMenu.hasMenuLearningAssessment}" routerLinkActive="active">
              @if (canShowMenu.hasMenuLearningAssessment) {
                <a
                  routerLink="/learning-assessment/assignments"
                  role="menuitem"
                  >
                  Assignments
                </a>
              }
              @if (!canShowMenu.hasMenuLearningAssessment) {
                <span class="noLink" aria-label="Assignments - You do not have access to this page"
                  >
                  Assignments
                </span>
              }
            </li>
            <li [ngClass]="{'inactiveMenuItem': !canShowMenu.hasMenuLearningAssessment}" routerLinkActive="active">
              @if (canShowMenu.hasMenuLearningAssessment) {
                <a
                  routerLink="/learning-assessment/courses"
                  role="menuitem"
                  >
                  Courses
                </a>
              }
              @if (!canShowMenu.hasMenuLearningAssessment) {
                <span class="noLink" aria-label="Courses - You do not have access to this page"
                  >
                  Courses
                </span>
              }
            </li>
            <li [ngClass]="{'inactiveMenuItem': !canShowMenu.hasMenuLearningAssessment}" routerLinkActive="active">
              @if (canShowMenu.hasMenuLearningAssessment) {
                <a
                  routerLink="/learning-assessment/rubrics"
                  role="menuitem"
                  >
                  Rubrics
                </a>
              }
              @if (!canShowMenu.hasMenuLearningAssessment) {
                <span class="noLink" aria-label="Rubrics - You do not have access to this page"
                  >
                  Rubrics
                </span>
              }
            </li>
            <li [ngClass]="{'inactiveMenuItem': !canShowMenu.hasMenuLearningAssessment}" routerLinkActive="active">
              @if (canShowMenu.hasMenuLearningAssessment) {
                <a
                  routerLink="/learning-assessment/analysis/courses"
                  role="menuitem"
                  >
                  Visualizations
                </a>
              }
              @if (!canShowMenu.hasMenuLearningAssessment) {
                <span class="noLink" aria-label="Visualizations - You do not have access to this page"
                  >
                  Visualizations
                </span>
              }
            </li>
            <li [ngClass]="{'inactiveMenuItem': !canShowMenu.hasMenuLearningAssessment}">
              @if (canShowMenu.hasMenuLearningAssessment) {
                <a routerLink="/learning-assessment/new-assignment"
                  >
                  Create New Assignment
                </a>
              }
              @if (!canShowMenu.hasMenuLearningAssessment) {
                <span class="noLink" aria-label="Create a new Assignment - You do not have access to this page"
                  >
                  Create New Assignment
                </span>
              }
            </li>
            <li [ngClass]="{'inactiveMenuItem': !canShowMenu.hasMenuLearningAssessment}">
              @if (canShowMenu.hasMenuLearningAssessment) {
                <a routerLink="/learning-assessment/new-assignment"
                  >
                  Create New Course
                </a>
              }
              @if (!canShowMenu.hasMenuLearningAssessment) {
                <span class="noLink" aria-label="Create a new Assignment - You do not have access to this page"
                  >
                  Create New Course
                </span>
              }
            </li>
            <li [ngClass]="{'inactiveMenuItem': !canShowMenu.hasMenuLearningAssessment}">
              @if (canShowMenu.hasMenuLearningAssessment) {
                <a routerLink="/learning-assessment/manage-rubric"
                  queryParams="{mode: 'create'}"
                  >
                  Create New Rubric
                </a>
              }
              @if (!canShowMenu.hasMenuLearningAssessment) {
                <span class="noLink" aria-label="Create a new Rubric - You do not have access to this page"
                  >
                  Create New Rubric
                </span>
              }
            </li>
          </ul>
        }
      </li>
    }
    <!--
    <li role="none" class="hasSubMenu" [ngClass]="{'menuOpen':analyticsOpen}"
      *ngIf="canShowMenu.reports || canShowMenu.hasMenuLearningAssessment"
      >
      <a href="#analyticsMenu"
        role="menuitem"
        (click)="toggleAnalyticsOpen($event)"
        aria-haspopup="true"
        [attr.aria-expanded]="analyticsOpen"
        >
        ANALYTICS
      </a>
      <ul class="submenu inlineList" *ngIf="analyticsOpen" id="analyticsMenu" aria-label="reports">
        <li [ngClass]="{'inactiveMenuItem': !canShowMenu.reports}" routerLinkActive="active">
          <a
            uiSref="selectReportTypeState"
            role="menuitem"
            *ngIf="canShowMenu.reports"
            >
            Reports
          </a>
          <span class="noLink" aria-label="Reports - You do not have access to this page"
            *ngIf="!canShowMenu.reports">
            Reports
          </span>
        </li>
        <li [ngClass]="{'inactiveMenuItem': !canShowMenu.hasMenuLearningAssessment}" routerLinkActive="active">
          <a
            uiSref="myCoursesAnalysis"
            role="menuitem"
            *ngIf="canShowMenu.hasMenuLearningAssessment"
            >
            Visualizations
          </a>
          <span class="noLink" aria-label="Visualizations - You do not have access to this page"
            *ngIf="!canShowMenu.hasMenuLearningAssessment">
            Visualizations
          </span>
        </li>
      </ul>
    </li>
    -->
    @if (canShowMenu.credentials) {
      <li routerLinkActive="active">
        <a routerLink="/faculty-roster">Faculty Roster</a>
      </li>
    }
    @if (canShowMenu.institutions) {
      <li routerLinkActive="active">
        <a routerLink="/accreditation/institutions">Institutions</a>
      </li>
    }
    @if (canShowMenu.institutionsDirectory) {
      <li routerLinkActive="active">
        <a routerLink="/directory/institutions">Directory</a>
      </li>
    }
    @if (canShowMenu.programsDirectory) {
      <li routerLinkActive="active">
        <a routerLink="/directory/programs">Directory</a>
      </li>
    }
    @if(canShowMenu.federationDirectory){
      <li routerLinkActive="active">
        <a routerLink="/directory/federation">Members</a>
      </li>
    }
    @if (canShowMenu.showApplicationTab) {
      <li routerLinkActive="active">
        <a routerLink="/applications">Applications</a>
      </li>
    }
    @if (canShowMenu.evaluators) {
      <li routerLinkActive="active">
        <a routerLink="/accreditation/reviewers">Reviewers</a>
      </li>
    }
    @if (canShowMenu.annualReportsTemplateEdit) {
      <li routerLinkActive="active">
        <a routerLink="/directory/annual-report-template-editor" tabindex=0>Annual Reports Template</a>
      </li>
    }
  </ul>
}
